import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PublicSiteConfig } from '../../../../services/publicSiteConfig.service';
import { DropdownUser } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { HelperService } from 'src/services/helperService';
import { Observable } from 'rxjs/internal/Observable';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { catchError, map, tap, throwError } from 'rxjs';
import { APIcountryService } from 'src/services/api-services/api-country-service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { UsersComponent } from '../../users.component';
import { MatRadioChange as MatRadioChange } from '@angular/material/radio';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';

const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};
// ViewEncapsulation.None is takes only local sass styles
@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.dialog.html',
    styleUrls: ['./create-user.dialog.sass'],
    standalone: false
})
export class CreateUserDialog extends PublicSiteConfigBaseComponent implements OnInit {
  userIncadea: boolean = false;
  userMix: boolean = false; //Is a user who belongs to regular booking and incadea booking
  companyID: string ='';
  languageNew: string ='';
  countryName: string='';
  firstName: string='';
  lastName: string = '';
  email: string = '';
  isLoadingSave:boolean = true;
  isSaving : boolean = true;
  isActive: boolean = false;
  createNewUser:DropdownUser ={} as DropdownUser;
  ownerRoleId: number = this.helperService.user.role.roleId
  countryId: number = this.helperService.user.countryId
  retailId: number= this.helperService.user.retailId
  roleId: number = 0
  workshopId: number = 0
  advisorId: number = 0
  getDropdowns$: Observable<DropdownUser[]> =  new Observable<DropdownUser[]>();
  countryIdSelect$: Observable<any[]> =  new Observable<any[]>();
  graphDropdowns$: Observable<any[]> =  new Observable<any[]>();
  retailList: any[] =  [];
  workshopList: any [] = [];
  AdvisorList: any [] = [];

  //This has the spaces that the form needs and the validations that are required are also included.
  createUserForm = this.fb.group({
    name:["", [ Validators.required,noSpecialCharsValidator ]],
    lastName:["", [ Validators.required,noSpecialCharsValidator ]],
    email:["", [  Validators.required,emailValidator,noSpecialCharsValidator ]],
    language:["", [ Validators.required ]],
    rol:[0, [ Validators.required ]],
    workshopName:[0,[ Validators.required ]],
    advisorName:[0],
    retailName:[0],
    countryName : [0],
    isActive : false,
    userIncadea: [false, [ Validators.required ]],
    userMix: [false],
    companyID: [""],
  })

  get  userMixControl(): FormControl {
    return this.createUserForm.get("userMix") as FormControl;
  }
  get  userIncadeaControl(): FormControl {
    return this.createUserForm.get("userIncadea") as FormControl;
  }

  get  companyIDControl(): FormControl {
    return this.createUserForm.get("companyID") as FormControl;
  }

  get  nameControl(): FormControl {
    return this.createUserForm.get("name") as FormControl;
  }
  get  lastNameControl(): FormControl {
    return this.createUserForm.get("lastName") as FormControl;
  }

  get  emailControl(): FormControl {
    return this.createUserForm.get("email") as FormControl;
  }

  get  languageControl(): FormControl {
    return this.createUserForm.get("language") as FormControl;
  }

  get  rolControl(): FormControl {
    return this.createUserForm.get("rol") as FormControl;
  }

  get  workshopNameControl(): FormControl {
    return this.createUserForm.get("workshopName") as FormControl;
  }

  get  advisorNameControl(): FormControl {
    return this.createUserForm.get("advisorName") as FormControl;
  }

  get  retailNameControl(): FormControl {
    return this.createUserForm.get("retailName") as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    public helperService: HelperService,
    public override publicSiteConfig:PublicSiteConfig,
    public userManagmentService: APIUserManagamentService,
    public selectWorkshop: APIServiceAdvisorService,
    public countriesService:APIcountryService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<UsersComponent>,
  ) 
  {
    super(publicSiteConfig);
  }

  protected override afterConfigLoaded(): void {
    // When are in the profile super admin support only send owneRoleId and return country and role list
    // this.helperService.TitlePage = 'Create Users'
    if(this.ownerRoleId === 7){
      this.graphDropdowns$ = forkJoin([
        this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId)
      ]);
    }
    else{
      // When are in the profile super retail send parameters and return role list
      this.createUserForm.patchValue({retailName:this.helperService.user.retailId,countryName:this.helperService.user.countryId})
      //A forkJoin is used because the response have two arrays
      this.graphDropdowns$ = forkJoin([
        this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId,this.countryId.toString(),undefined,this.retailId.toString()),
        this.countryIdSelect$=this.countriesService?.get(this.countryId.toString())
        .pipe(
          catchError((error: any) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }
            // Handle validation error here
            console.error('Validation Error:', error);
            // Rethrow the error to propagate it downstream
            return throwError(() => error);
          })
        ),
      ]);
    }
  }

  // Function used for super admin support profile and return country name
  selectCountry(countryId:number) {

    this.createUserForm.patchValue({
      rol: 0,
      workshopName: 0,
      advisorName: 0,
      retailName: 0
    })

  }  
  
  //Use when the user is super admin support and return retail list
  selectRetailId(){
    this.createUserForm.patchValue({
      workshopName: 0,
      advisorName: 0,
      retailName: 0
    })

    this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.createUserForm.value.countryName), String(this.createUserForm.value.rol))
    .pipe(
      map(response => {
        this.retailList = response[0]
      })
    ).subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })
  }

  // Use for the super retail and super admin support profile and return workshop list
  selectworkshop(){
    this.createUserForm.patchValue({
      workshopName: 0,
      advisorName: 0,

    })

    this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.createUserForm.value.countryName), String(this.createUserForm.value.rol),String(this.createUserForm.value.retailName))
    .pipe(
      tap(response => {
        this.workshopList = response[0]
      })
    ).subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })
  }

  // Use for the super retail and super admin support profile and return Advisor list
  selectAdvisor(){
    this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.createUserForm.value.countryName), String(this.createUserForm.value.rol),String(this.createUserForm.value.retailName),String(this.createUserForm.value.workshopName))
    .pipe(
      tap(response => {
        this.AdvisorList = response[0]
      })
    ).subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })
  }

  // In this method save the created user
  onSaveCreateUser(){
    this.isLoadingSave=false
    let retailIdLocation:any= null
      if(this.createUserForm.value.rol === 4){ retailIdLocation = String(this.createUserForm.value.retailName) }
    //transformation from boolean to string because only that response string is needed in the service
    let isActiveString = "0"
    let userIncadeaString = "0"
    if(this.createUserForm.value.isActive === true){
      isActiveString = "1"
    }
    if(this.createUserForm.value.userIncadea === true){
      userIncadeaString = "1"
    }

    //It is sent in this format because the values are being brought from the form
    this.userManagmentService?.createUser(String(this.createUserForm.value.name),String(this.createUserForm.value.lastName),String(this.createUserForm.value.email),String(this.createUserForm.value.countryName),String(this.createUserForm.value.language),String(this.createUserForm.value.rol),isActiveString, userIncadeaString,String(this.createUserForm.value.userMix), String(this.createUserForm.value.companyID) ,retailIdLocation,String(this.createUserForm.value.workshopName),String(this.createUserForm.value.advisorName))
    .pipe(
      tap((response)=>{

        if(response.Result=== "User Created Successfully"){
          const translateTextSuccess = this.translate.instant("ToastCreateUser",{User:String(this.createUserForm.value.name)+ " " + String(this.createUserForm.value.lastName)});

          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateTextSuccess
          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
            this.isLoadingSave=true
            this.dialogRef.close();

        }
      }),
    ).subscribe(
      {
        error: (failed) => {
          // Manejo de error 401
          if (failed.status === 401) {
            this.helperService.logoutToken();
          }

          const translateTextError = this.translate.instant("ToastCreateUserError");
          this.helperService.showAlert =true
          this.helperService.typeAlert ="error"
          this.helperService.messageAlert =translateTextError
          setTimeout(() => {
            this.helperService.showAlert =false

            }, 7000)
            this.dialogRef.close();
        },
      }
    )
  }

  //validates that the required parameters are complete
  formsValidations(): boolean {
    const isFormValidationInvalid = this.createUserForm!.invalid
    return isFormValidationInvalid;

  }

  toggleSwitch() {
    this.isActive = !this.isActive;
  }

  // Update roles dropdown incadea
  onRadioChange(event: MatRadioChange) {
    if (this.ownerRoleId === 7) {
      this.graphDropdowns$ = forkJoin([
        this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId).pipe(
          map((response)=>{
            let roles:any[] = []
            if(this.createUserForm.value.userIncadea === true){
              response[1].forEach(role => {
                if(role.RoleId === 3 || role.RoleId === 4 ){
                  roles[roles.length] = role
                }
              });
              response[1] = roles
            }
            return response
          }),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          })
        )
      ]);
    }
  }

  onRadioChangeUserMix(event: MatRadioChange){
    if(this.createUserForm.value.userMix === true){
      this.createUserForm.patchValue({
        userIncadea : false
      })
    }
  }

}
